<template>
  <div>
    <notifications group="label" position="top left" class="notice"></notifications>
    <div class="section-labelimage">
      <div class="label-radio">
        <div v-if="type === 'correct'">
            <h6>Reason</h6>
            <div class="multiline">
              <b-form-textarea
                id="textarea"
                v-model="reason"
                placeholder="reason..."
                rows="1"
                max-rows="3"
              ></b-form-textarea>
          </div>
        </div>
        <div class="label-radio__body">
          <p>Alert type</p>
          <input
            type="radio"
            id="none"
            style="cursor:pointer;"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_NONE"
            v-model="alert"
          />
          <label for="none" style="cursor:pointer;">None</label>
          <br />
          <input
            type="radio"
            id="pone"
            style="cursor:pointer;"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_PRONE"
            v-model="alert"
          />
          <label for="pone" style="cursor:pointer;">Prone</label>

          <br />
          <input
            type="radio"
            id="cover"
            style="cursor:pointer;"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_FACE_COVER"
            v-model="alert"
          />
          <label for="cover" style="cursor:pointer;">Cover</label>

          <br />
          <input
            type="radio"
            id="nobody"
            style="cursor:pointer;"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_NOT_IN_BED"
            v-model="alert"
          />
          <label for="nobody" style="cursor:pointer;">No body</label>
        </div>
        <div class="label-radio__box">
          <p>Box</p>
          <div class="label-type">
            <div class="label-type__item">

              <div v-if="drawingType === 'Person'" class="label-type__item--choosed bg-light-green"></div>
              <div v-else class="label-type__item--color bg-light-green"></div>
              <div class="label-type__item--type">Person</div>

              <div v-if="drawingType === 'Face'" class="label-type__item--choosed bg-purple"></div>
              <div v-else class="label-type__item--color bg-purple"></div>
              <div class="label-type__item--type">Face</div>

            </div>
            <div class="label-type__item">

              <div v-if="drawingType === 'Head'" class="label-type__item--choosed bg-red"></div>
              <div v-else class="label-type__item--color bg-red"></div>
              <div class="label-type__item--type">Head</div>

              <div v-if="drawingType === 'Hand'" class="label-type__item--choosed bg-corn-blue"></div>
              <div v-else class="label-type__item--color bg-corn-blue"></div>
              <div class="label-type__item--type">Hand</div>

            </div>
            <div class="label-type__item">

              <div v-if="drawingType === 'Leg'" class="label-type__item--choosed bg-light-yellow"></div>
              <div v-else class="label-type__item--color bg-light-yellow"></div>
              <div class="label-type__item--type">Leg</div>

              <div v-if="drawingType === 'Bed'" class="label-type__item--choosed bg-green"></div>
              <div v-else class="label-type__item--color bg-green"></div>
              <div class="label-type__item--type">Bed</div>

            </div>
          </div>
        </div>
        <button class="btn btn-info" @click.prevent="hideBox()">{{PropsHideBox}} box (Esc)</button>
      </div>
      <labeledImage
      :PropsBatchDate="PropsBatchDate"
      :PropsRoi="PropsRoi"
      :PropsImgName="PropsImgName"
      :PropsBoxTimes="PropsBoxTimes"
      :PropsHideBox="PropsHideBox"
      :PropsBatchType="PropsBatchType"
      :PropsLevelOne="PropsLevelOne"
      >
      </labeledImage>
    </div>
    <div class="label-fun">
      <div v-if="is_uncertain">
        <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="uncertain()">
        cancel Uncertain</button>
      </div>
      <div v-else>
        <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="uncertain()">
          Uncertain</button>
      </div>

      <div v-if="is_skip">
        <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="skip()">
        cancelSkip</button>
      </div>
      <div v-else>
        <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="skip()">
          Skip</button>
      </div>
      <button
        class="label-fun__btn btn btn-secondary"
        :disabled="current===1"
        @click.prevent="backward()"
      >
        <i class="fas fa-backward"></i>
      </button>
      <button
        class="label-fun__btn btn btn-secondary"
        :disabled="total===current"
        @click.prevent="forward()"
      >
        <i class="fas fa-forward"></i>
      </button>
      <button type="button" class="label-fun__btn btn btn-primary"
        @click.prevent="storeAndNext()">{{type}} &amp; Next</button>
      <p style="font-size:24px; align-items: center;">{{current}}/{{total}}</p>
    </div>
  </div>
</template>

<script>
import client from '@/api/client';
import labeledImage from '@/components/labeledImage/labeledImage.vue';

export default {
  components: { labeledImage },
  data() {
    return {
      PropsBatchType: 'sleep_main',
      PropsBatchDate: null,
      PropsImgName: null,
      PropsBoxTimes: null,
      PropsHideBox: 'Hide',
      PropsLevelOne: true,
      PropsRoi: null,
      total: 0,
      current: 0,
      alert: '', // alert type
      imageNameList: [],
      drawingType: null,
      is_skip: false,
      is_uncertain: false,

      type: '',
      batch_date: '',
      reason: '',
    };
  },
  methods: {
    loadRejectedList() {
      const vm = this;
      const params = {
        batch_date: vm.batch_date,
      };
      client.get(`metas/${vm.PropsBatchType}/rejected?`, params).then((res) => {
        console.log(res);
        res.metas.forEach((item) => {
          vm.imageNameList.push(item.name);
        });
        vm.total = vm.imageNameList.length;
        vm.nextLabel();
      });
    },
    getMeta() {
      const vm = this;
      client.get(`/meta/sleep_main/${vm.imageNameList[vm.current - 1]}`).then((res) => {
        console.log('get');
        console.log(res);
        vm.updateUI(res);
      });
    },
    nextLabel() {
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;
        vm.getMeta();
      } else if (vm.type === 'correct') {
        this.$bvModal.msgBoxOk('Correct completed').then((value) => {
          vm.$router.push('/task');
        });
      } else {
        client.get('/meta/sleep_main/to_label').then((res) => {
          if (res == 404) {
            this.$bvModal.msgBoxOk('Label completed').then((value) => {
              vm.$router.push('/task');
            });
            return;
          }
          vm.imageNameList.push(res.name);
          vm.updateUI(res);
          vm.current += 1;
          vm.total += 1;
          console.log(res);
        });
      }
    },
    updateUI(response) {
      const vm = this;
      if (response.roi) {
        vm.PropsRoi = response.roi;
      } else {
        vm.PropsRoi = null;
      }
      if (response.is_uncertain) {
        vm.is_uncertain = response.is_uncertain;
      } else {
        vm.is_uncertain = false;
      }
      vm.is_skip = response.is_skip;
      vm.PropsBatchDate = response.batch_date;
      vm.PropsImgName = response.name;
      vm.PropsBoxTimes = response.result_bboxes;

      if (response.label_alert_type) {
        vm.alert = response.label_alert_type;
      } else {
        vm.alert = response.result_alert_type;
      }

      if ('reason' in response) {
        vm.reason = response.reason;
      } else {
        vm.reason = 'None';
      }
    },
    skip() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, vm.alert, !vm.is_skip, false);
    },
    uncertain() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, vm.alert, false, !vm.is_uncertain);
    },
    backward() {
      const vm = this;
      vm.current -= 1;
      vm.getMeta();
    },
    forward() {
      const vm = this;
      vm.current += 1;
      vm.getMeta();
    },
    storeAndNext() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, vm.alert, vm.is_skip, vm.is_uncertain);
    },
    updateLabel(name, label_alert_type, is_skip, is_uncertain) {
      const vm = this;
      const body = {
        name,
        label_alert_type,
        is_skip,
        is_uncertain,
      };
      let url = '';
      if (vm.type == 'label') {
        url = `meta/${vm.PropsBatchType}`;
      } else {
        url = `meta/${vm.PropsBatchType}/correct_reject`;
      }
      client.post(url, null, body).then((res) => {
        vm.nextLabel();
      });
    },
    hideBox() {
      const vm = this;
      if (vm.PropsHideBox === 'Hide') {
        vm.PropsHideBox = 'Show';
      } else {
        vm.PropsHideBox = 'Hide';
      }
    },

  },
  mounted() {
    this.batch_date = this.$route.params.batch_date;
    this.type = this.$route.params.type;
    if (!this.type) {
      this.type = 'label';
    }
    console.log(this.type, this.batch_date);
    const vm = this;

    if (this.type === 'correct') {
      vm.loadRejectedList();
    } else {
      vm.nextLabel();
    }

    // eslint-disable-next-line
    document.onkeydown = function (e) {
      const keycode = {
        KeyD: () => {
          if (vm.alert === 'CUBO_ALERT_NONE') {
            vm.alert = 'CUBO_ALERT_PRONE';
          } else if (vm.alert === 'CUBO_ALERT_PRONE') {
            vm.alert = 'CUBO_ALERT_FACE_COVER';
          } else if (vm.alert === 'CUBO_ALERT_FACE_COVER') {
            vm.alert = 'CUBO_ALERT_NOT_IN_BED';
          } else if (vm.alert === 'CUBO_ALERT_NOT_IN_BED') {
            vm.alert = 'CUBO_ALERT_NONE';
          }
        },
        KeyE: () => {
          if (vm.alert === 'CUBO_ALERT_NONE') {
            vm.alert = 'CUBO_ALERT_NOT_IN_BED';
          } else if (vm.alert === 'CUBO_ALERT_PRONE') {
            vm.alert = 'CUBO_ALERT_NONE';
          } else if (vm.alert === 'CUBO_ALERT_FACE_COVER') {
            vm.alert = 'CUBO_ALERT_PRONE';
          } else if (vm.alert === 'CUBO_ALERT_NOT_IN_BED') {
            vm.alert = 'CUBO_ALERT_FACE_COVER';
          }
        },
        Escape: () => {
          vm.hideBox();
        },
        ArrowUp: () => {
          vm.skip();
        },
        Enter: () => {
          vm.storeAndNext();
          e.preventDefault();
        },
        ArrowLeft: () => {
          if (vm.current !== 1) {
            vm.backward();
          }
        },
        ArrowRight: () => {
          if (vm.total !== vm.current) {
            vm.forward();
          }
        },
      };
      keycode[e.code]();
    };
  },
  watch: {
  },

};
</script>
